import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/internal/projects/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/internal/projects/$id/overview',
      params,
      replace: true,
    })
  },
})
